import BaseTableNew from 'components/atoms/base-table/new';
import useUser from 'utils/useUser';

import { useColumns } from './columns';
import s from './styles.module.scss';
import MobileTable from './mobile-table';

import type { IAssignTool } from 'infrastructure/interfaces';
import type { FC } from 'react';

interface AssignToolTableProps {
  patients?: IAssignTool[];
  isLoading: boolean;
  toggleOpen: () => void;
}

const AssignToolTable: FC<AssignToolTableProps> = ({
  patients,
  isLoading,
  toggleOpen,
}) => {
  const columns = useColumns(toggleOpen);
  const { isMobileDevice } = useUser();

  if (isMobileDevice) {
    return (
      <MobileTable
        patients={patients}
        isLoading={isLoading}
        toggleOpen={toggleOpen}
      />
    );
  }

  return (
    <BaseTableNew
      rowKey="guid"
      columns={columns}
      items={patients ?? []}
      bordered
      loading={isLoading}
      className={s['queue-table']}
      dataCy="assign-tool-table"
    />
  );
};
export default AssignToolTable;
